//Extract zipcode from the fullAddress if it is empty
const regex = /\d{4}(?=\D*$)/

export const extractZipCode = (fullAddress: string | undefined) => {
  if (!fullAddress) {
    return undefined
  }
  const zipCode = regex.exec(fullAddress)
  if (zipCode) {
    return zipCode[0]
  }
  return undefined
}

export const isValidZipCode = (zipCode: string | undefined, addressShort: string | undefined) => {
  if (zipCode?.length === 4) {
    return true
  }
  if (extractZipCode(addressShort)?.length === 4) {
    return true
  }
  return false
}
